export const getAgGridFilter = (columnSqlType) => {
    switch (columnSqlType) {
        case "bigint":
        case "decimal":
        case "money":
        case "smallmoney":
        case "float":
        case "int":
        case "real":
        case "smallint":
        case "tinyint":
            return { filter: "agNumberColumnFilter" };

        case "char":
        case "nchar":
        case "ntext":
        case "nvarchar":
        case "text":
        case "varchar":
        case "uniqueidentifier":
            return { filter: "agTextColumnFilter" };

        case "datetime":
        case "smalldatetime":
        case "date":
        case "time":
        case "datetime2":
            return { filter: "agDateColumnFilter" };

        case "bit":
            return {
                filter: "agSetColumnFilter",
                filterParams: {
                    values: ["true", "false"]
                }
            };


        default:
            return false;
    }
}